import LoggerFactory from './logger-factory';

export default LoggerFactory;
